import {
    CreditCardOutlined,
    StarOutline,
    StarOutlined,
    SupportAgent,
} from '@mui/icons-material'
import { Box, Card, Stack, Typography, Button, LinearProgress } from '@mui/joy'
import dayjs from 'dayjs'

type Props = {}

const ChatApiBillingPage = (props: Props) => {
    return (
        <>
            <Box
                sx={{
                    my: 'auto',
                    py: 2,
                    pb: 5,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                    width: 1000,
                    maxWidth: '100%',
                    mx: 'auto',
                    borderRadius: 'sm',
                    '& form': {
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 2,
                    },
                }}
            >
                <Card>
                    <Stack gap={4} sx={{ mb: 2 }}>
                        <Stack gap={1}>
                            <Typography
                                level="h3"
                                startDecorator={<CreditCardOutlined />}
                            >
                                Manage your Chat API billing
                            </Typography>
                        </Stack>
                        {/* {upgrade ? (
                            <BillingPlansGrid
                                user={user}
                                subscription={subscription}
                                products={products}
                            />
                        ) : ( */}
                        <>
                            <Stack gap={2}>
                                <Stack gap={1}>
                                    <Typography level="body-md">
                                        Your current plan
                                    </Typography>
                                    <Typography level="title-md">
                                        Free
                                    </Typography>
                                </Stack>
                                <Stack gap={1}>
                                    <Typography level="body-md">
                                        Current billing period
                                    </Typography>
                                    <Typography level="title-md">
                                        {/* {dayjs
                                            .unix(subscription.start)
                                            .format('DD MMMM YYYY')}{' '}
                                        -{' '}
                                        {dayjs
                                            .unix(subscription.until)
                                            .format('DD MMMM YYYY')} */}
                                    </Typography>
                                </Stack>
                                <Box>
                                    <Typography level="title-md">
                                        Current usage
                                    </Typography>
                                    <Stack
                                        direction="row"
                                        justifyContent="space-between"
                                        spacing={2}
                                        sx={{
                                            mt: 2,
                                        }}
                                    >
                                        <Typography level="title-md">
                                            Users
                                        </Typography>
                                        <Typography level="title-sm">
                                            1/1
                                        </Typography>
                                    </Stack>
                                    <LinearProgress
                                        variant="outlined"
                                        value={100}
                                        determinate
                                        sx={{ my: 1 }}
                                    />
                                    <Stack
                                        direction="row"
                                        justifyContent="space-between"
                                        spacing={2}
                                    >
                                        <Typography level="title-md">
                                            Messengers
                                        </Typography>
                                        <Typography level="title-sm">
                                            1/4
                                        </Typography>
                                    </Stack>
                                    <LinearProgress
                                        variant="outlined"
                                        value={25}
                                        determinate
                                        sx={{ my: 1 }}
                                    />
                                </Box>
                            </Stack>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flex: 1,
                                    gap: 2,
                                    justifyContent: 'center',
                                }}
                            >
                                <Button
                                    color="primary"
                                    variant="outlined"
                                    startDecorator={<SupportAgent />}
                                    // onClick={openSupportChat}
                                >
                                    Contact Sales
                                </Button>
                                <Button
                                    startDecorator={<StarOutlined />}
                                    color="primary"
                                    onClick={() => {
                                        // setUpgrade(true)
                                    }}
                                >
                                    Upgrade Plan
                                </Button>
                            </Box>
                        </>
                        {/* )} */}
                    </Stack>
                </Card>
            </Box>
            {/* ) */}
        </>
    )
}

export default ChatApiBillingPage
